CSS.insert(`

    .salonhubpay.provider-ccv-cloud-connect window-content iframe {
        clip-path: inset(30px 30px);
    }

    ui-window.cashierWindow .status div {
        display: flex;
        align-items: center;
        font-size: 1.2em;
        color: #000;
    }

    ui-window.cashierWindow .status div img {
        margin-right: 10px;
    }

    ui-window.cashierWindow .explanation {
        margin-top: 20px;
        font-size: 0.85em;
        color: #000;
    }

    ui-window.cashierWindow .amount { text-align: left; font-size: 2em; margin-top: 10px; }
    ui-window.cashierWindow .loader { margin-top: 6px;width: 20px; height: 20px; background: url(${_ROOT}images/loader-regular.gif) center no-repeat; background-size: 20px 20px; }
    @media (min-resolution: 2dppx), (-webkit-min-device-pixel-ratio: 2) { ui-window.cashierWindow .loader { background-image: url(${_ROOT}images/loader-regular@2x.gif); } }
    ui-window.cashierWindow window-frame > footer { border-top: none; }
`);
DeviceManager.Internal.PaymentTerminal.SalonhubPay = {
  getCapabilities: function () {
    return {
      id: 'salonhub-pay',
      name: 'Salonhub Pay',
      features: ['transaction', 'detectMethod', 'finalPayment', 'resumePayment', 'checkPayment', 'chooseTerminal']
    };
  },
  startTransaction: async function (options) {
    let skipInterface = false;
    let reference = null;
    let provider = options.provider || 'ccv-cloud-connect';

    /* Check if the terminal is available */

    let status = await new Promise(resolve => {
      new DeviceManager.Internal.PaymentTerminal.Wait({
        endpoint: options.endpoint,
        client: options.client,
        salon: options.salon,
        device: options.device,
        provider: provider,
        onResult: status => resolve(status)
      });
    });
    if (status == 'stopped') {
      return {
        status: _PAYMENT_PAY_CANCELLED
      };
    }
    if (status == 'timeout') {
      return {
        status: _PAYMENT_PAY_REJECTED
      };
    }
    if (status == 'manualintervention') {
      return {
        status: _PAYMENT_PAY_INTERVENTION
      };
    }
    if (status == 'error') {
      return {
        status: _PAYMENT_PAY_CONNECTION_FAILED
      };
    }

    /* Start transaction on the server */

    let parameters = {
      location: options.location,
      payment: options.payment,
      amount: options.amount,
      device: options.device
    };
    let createResponse = await fetch(`${options.endpoint}api/Payments.Terminals/${options.resume ? 'resume' : 'create'}/${options.client}:${options.salon}?provider=${provider}`, {
      method: 'POST',
      body: JSON.stringify(parameters),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    let createResult;
    if (!createResponse.ok) {
      if (options.resume) {
        return {
          status: _PAYMENT_PAY_RESUME_FAILED
        };
      }
      try {
        let createError = await createResponse.json();
        if (createError.reason == 'bad_credentials') {
          return {
            status: _PAYMENT_PAY_BAD_API_KEY
          };
        }
        if (createError.reason == 'invalid_config') {
          return {
            status: _PAYMENT_PAY_BAD_API_KEY
          };
        }
        if (createError.reason == 'bad_terminal') {
          return {
            status: _PAYMENT_PAY_TERMINAL_UNKNOWN
          };
        }
        if (createError.reason == 'connection_error') {
          return {
            status: _PAYMENT_PAY_NETWORK_FAILED
          };
        }
        if (createError.reason == 'rejected') {
          return {
            status: _PAYMENT_PAY_REJECTED
          };
        }
        if (createError.reason == 'unknown') {
          return {
            status: _PAYMENT_PAY_NETWORK_UNKNOWN
          };
        }

        /* We encountered a server error on the API side, but that does not mean the payment failed. */

        if (createError.reason == 'server_error') {
          /* First thing we do is wait for 15 seconds */

          document.fire('shell:showPaymentStatus');
          await new Promise(resolve => setTimeout(resolve, 1000 * 15));

          /* Then we try to get the payment status, but not by reference, because we don't have that */

          let getResponse = await fetch(`${options.endpoint}api/Payments.Terminals/getByPayment/${options.client}:${options.salon}?payment=${options.payment}`);
          let getResult = await getResponse.json();
          if (getResult.status == 'pending' || getResult.status == 'error') {
            await new Promise(resolve => setTimeout(resolve, 1000 * 15)); /* Wait another 15 seconds */

            getResponse = await fetch(`${options.endpoint}api/Payments.Terminals/getByPayment/${options.client}:${options.salon}?payment=${options.payment}`);
            getResult = await getResponse.json();
            if (getResult.status == 'pending' || getResult.status == 'error') {
              await new Promise(resolve => setTimeout(resolve, 1000 * 15)); /* Wait another 15 seconds */

              getResponse = await fetch(`${options.endpoint}api/Payments.Terminals/getByPayment/${options.client}:${options.salon}?payment=${options.payment}`);
              getResult = await getResponse.json();
            }
          }

          /* Wait for 200 ms */

          document.fire('shell:hidePaymentStatus');
          await new Promise(resolve => setTimeout(resolve, 200));

          /* Did we get an update from the API yet? */

          if (getResult.status == 'error' || !getResult.reference) {
            return {
              status: _PAYMENT_PAY_SERVER_ERROR
            };
          } else {
            skipInterface = true;
            reference = getResult.reference;
          }
        }
      } catch (e) {}
      if (!skipInterface) {
        return {
          status: _PAYMENT_PAY_CONNECTION_FAILED
        };
      }
    }
    if (!skipInterface) {
      createResult = await createResponse.json();
      reference = createResult.reference;
      if (createResult.log) {
        this.startIntercept();
      }
      if (createResult.events) {
        /* MultiSafePay SmartPOS: cashier screen with SSE stream for real-time payment status */

        let cashierWindow = new Window({
          className: 'cashierWindow',
          modal: true,
          width: 300
          // height:     220,
        });
        let amountText = new Element('div', {
          className: 'amount'
        });
        amountText.update(Formatter.currency(options.amount, 2));
        cashierWindow.container.appendChild(amountText);
        let statusPanel = new Widgets.Panel(cashierWindow, {
          className: 'status',
          style: 'page',
          data: 'loading',
          template: data => {
            return html`
                            ${data == 'loading' ? html`
                                <img src="../../../assets/icons/Color/icons/card.svg" width=32 height=32>
                                <span>Wachten op betaling...</span>
                            ` : ''}

                            ${data == 'success' ? html`
                                <img src="../../../assets/icons/Color/icons/ok.svg" width=32 height=32>
                                <span>De transactie is <b>geslaagd</b></span>
                            ` : ''}

                            ${data == 'cancelled' ? html`
                                <img src="../../../assets/icons/Color/icons/cancel.svg" width=32 height=32>
                                <span>De transactie is <b>gestopt</b></span>
                            ` : ''}

                            ${data == 'declined' ? html`
                                <img src="../../../assets/icons/Color/icons/blocked.svg" width=32 height=32>
                                <span>De transactie is <b>geweigerd</b></span>
                            ` : ''}
                        `;
          }
        });
        new Widgets.Panel(cashierWindow, {
          className: 'explanation',
          style: 'none',
          template: `
                        <p>
                            De transactie is gestart op het betaalterminal. Volg de instructies op het scherm van het betaalterminal om de transactie te voltooien.
                        </p>
                    `
        });
        let loader = new Element('div', {
          className: 'loader'
        });
        cashierWindow.footer.appendChild(loader);
        let cancelButton = new Widgets.Button(cashierWindow.navigation, {
          title: 'Annuleer',
          color: 'red',
          onClick: () => {
            fetch(`${options.endpoint}api/Payments.Terminals/cancel/${options.client}:${options.salon}?provider=${provider}&reference=${reference}`, {
              method: 'POST'
            });
          }
        });
        cashierWindow.show();
        await new Promise(resolve => {
          let streamUrl = createResult.events.stream.replace('https://', 'https://public.salonhub.nl/proxy/');
          let source = new EventSource(`${streamUrl}?token=${createResult.events.token}`);
          let resolved = false;
          let done = async status => {
            if (!resolved) {
              resolved = true;
              source.close();
              cancelButton.enabled = false;
              loader.style.display = 'none';
              if (status == 'completed') {
                statusPanel.data = 'success';
              } else if (status == 'cancelled') {
                statusPanel.data = 'cancelled';
              } else if (status == 'declined') {
                statusPanel.data = 'declined';
              }
              await new Promise(r => setTimeout(r, 5000));
              cashierWindow.close();
              resolve();
            }
          };
          source.addEventListener('session.order', event => {
            try {
              let data = JSON.parse(event.data);
              if (data.status == 'completed' || data.status == 'cancelled' || data.status == 'declined') {
                done(data.status);
              }
            } catch (e) {}
          });
        });
      } else {
        /* CCV: Create window to show the payment interface */

        let paymentInterface = new Window({
          className: 'salonhubpay provider-' + provider,
          modal: true,
          width: 520,
          height: 480
        });
        paymentInterface.show();
        let iframe = document.createElement('iframe');
        iframe.src = createResult.url;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none';
        iframe.style.visibility = 'hidden';
        paymentInterface.contents.appendChild(iframe);
        await new Promise(resolve => setTimeout(resolve, 500));
        iframe.style.visibility = 'visible';

        /* Wait for the payment to be completed */

        await new Promise(resolve => {
          window.addEventListener('message', event => {
            if (event.data.command && event.data.command == 'closePaymentInterface') {
              resolve();
            }
          });
        });

        /* Close the window */

        paymentInterface.close();
      }
      if (createResult.log) {
        this.stopIntercept();
      }
    }

    /* Get the result of the payment */

    let getResponse = await fetch(`${options.endpoint}api/Payments.Terminals/getByReference/${options.client}:${options.salon}?reference=${reference}`);
    let getResult = await getResponse.json();

    /* Payment is still pending, wait up to 1 minutes and poll */

    if (getResult.status == 'pending') {
      document.fire('shell:showPaymentStatus');
      await new Promise(resolve => setTimeout(resolve, 1000 * 30)); /* Wait 30 seconds */

      getResponse = await fetch(`${options.endpoint}api/Payments.Terminals/getByReference/${options.client}:${options.salon}?poll=true&reference=${reference}`);
      getResult = await getResponse.json();
      if (getResult.status == 'pending') {
        await new Promise(resolve => setTimeout(resolve, 1000 * 15)); /* Wait another 15 seconds */

        getResponse = await fetch(`${options.endpoint}api/Payments.Terminals/getByReference/${options.client}:${options.salon}?poll=true&reference=${reference}`);
        getResult = await getResponse.json();
        if (getResult.status == 'pending') {
          await new Promise(resolve => setTimeout(resolve, 1000 * 15)); /* Wait another 15 seconds */

          getResponse = await fetch(`${options.endpoint}api/Payments.Terminals/getByReference/${options.client}:${options.salon}?poll=true&reference=${reference}`);
          getResult = await getResponse.json();
        }
      }
      document.fire('shell:hidePaymentStatus');
    }

    /* Payment was successful */

    if (getResult.status == 'success') {
      let method = _PAYMENT_DEBITCARD_;
      if (getResult.method != 'debit') {
        method = _PAYMENT_CREDITCARD_;
      }
      let tips = typeof getResult.total === 'number' && typeof getResult.amount === 'number' && getResult.total > getResult.amount ? getResult.total - getResult.amount : 0;
      return {
        status: _PAYMENT_SUCCESS,
        data: {
          status: _PAYMENT_STATUS_SUCCESS,
          details: getResult.details,
          tips,
          method
        }
      };
    }

    /* Payment failed */

    if (getResult.status == 'failed') {
      return {
        status: _PAYMENT_SUCCESS,
        data: {
          status: _PAYMENT_STATUS_FAILED,
          reason: getResult.reason,
          message: ''
        }
      };
    }

    /* Payment status is unknown */

    return {
      status: _PAYMENT_SUCCESS,
      data: {
        status: _PAYMENT_STATUS_UNKNOWN
      }
    };
  },
  supports: function (feature) {
    if (feature == 'resumePayment') {
      return true;
    }
    if (feature == 'detectMethod') {
      return true;
    }
    if (feature == 'finalPayment') {
      return true;
    }
    if (feature == 'checkPayment') {
      return true;
    }
    if (feature == 'chooseTerminal') {
      return true;
    }
  },
  enabled: function (options) {
    return options.language == 'salonhub-pay';
  },
  /* Intercept the console output, for debugging purposes */

  startIntercept: function () {
    if (typeof ConsoleIntercept === 'undefined') {
      return;
    }
    DeviceManager.intercept = {
      reference: null,
      index: 0,
      actions: []
    };
    let abortShown = false;
    ConsoleIntercept.start(event => {
      try {
        if (event.message.includes('Polling done, received')) {
          let payload = event.message.split('Polling done, received')[1].trim();
          let data = JSON.parse(payload);
          data.actions.forEach(action => {
            if (action.type == 'SHOW_TEXT' && action.value.hasOwnProperty(String(DeviceManager.intercept.index))) {
              DeviceManager.intercept.actions.push({
                timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
                type: 'text',
                value: 'custom:' + action.value[String(DeviceManager.intercept.index)]
              });
              DeviceManager.intercept.index++;
            }
            if (action.type == 'SHOW_ABORT_TEXT' && !abortShown) {
              abortShown = true;
              DeviceManager.intercept.actions.push({
                timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
                type: 'text',
                value: 'abort'
              });
            }
            if (action.type == 'REDIRECT') {
              DeviceManager.intercept.actions.push({
                timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
                type: 'redirect',
                value: action.value
              });
            }
          });
          DeviceManager.intercept.reference = data.reference;
        }
        if (event.message.includes('Abort click done')) {
          DeviceManager.intercept.actions.push({
            timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
            type: 'clicked',
            value: 'abort'
          });
          DeviceManager.intercept.index++;
        }
      } catch (e) {}
    });
  },
  stopIntercept: function () {
    if (typeof ConsoleIntercept === 'undefined') {
      return;
    }
    ConsoleIntercept.stop();
    if (DeviceManager.intercept && DeviceManager.intercept.actions.length) {
      Telemetry.log({
        type: 'salonhub-pay',
        message: 'Console intercepted',
        details: {
          reference: DeviceManager.intercept.reference,
          actions: DeviceManager.intercept.actions
        }
      });
    }
  }
};
//# sourceMappingURL=salonhub-pay.js.map
